import { getUserAttributes } from '@mb/lib/customer';
import { getUserLang } from '@mb/lib/i18n';
import { handleSystemErrorReport } from '@mb/lib/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { config, siteId } from '../../config';
import { RootState } from '../../redux/store';

const DEFAULT_ERROR_MESSAGE = 'Failed to fetch quick filters data.';

const userLang = getUserLang();

export const fetchQuickFilters = createAsyncThunk<
  any,
  undefined,
  { state: RootState }
>('fetchQuickFilters/get', async (payload, thunkApi) => {
  try {
    const customer = getUserAttributes();
    const configLang =
      typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : 'US';
    const body = {
      siteId: siteId,
      lang: `${userLang}-${configLang}`,
      context: 'catalog',
      customer: {
        id: customer.customer_id,
        email: customer.email,
        projectId: Number(customer.current_project),
        country: customer.country,
        province: String(customer.state),
      },
    };

    const response = await fetch(config.endpoints.quickFilters, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .catch((e) => {
        console.log('fetchQuickFilters', e);
      });
    return response;
  } catch (e: any) {
    const message = e.response?.data?.message ?? DEFAULT_ERROR_MESSAGE;
    handleSystemErrorReport(
      `Error fetchQuickFilters: ${message}`,
      'quick_filters',
    );
    return thunkApi.rejectWithValue({ message });
  }
});
